import React from 'react'
import LayoutAdmin from '../../components/layout/LayoutAdmin'

const SAAdmins = () => {
  return (
    <LayoutAdmin>
      <h2 className="text-xl font-semibold mb-4">Super Admin - Manage Admins</h2>
      <div className="bg-white border rounded p-4">This is a dummy Super Admin Manage Admins page.</div>
    </LayoutAdmin>
  )
}

export default SAAdmins


